import { IItem } from 'app/components/search-bar';
import { SEARCH_BAR_VIRTUAL_ITEM_CLASS } from 'app/theme/global-styles/search-bar-styles/searchBarStyles';

type Facility = {
  id?: string;
  name?: string;
  facilityAlias?: string;
  companyAlias?: string;
  isActive?: boolean | null;
  isVirtual?: boolean | null;
};

export function convertToSearchableFacility(
  { id, name, companyAlias, facilityAlias, isActive, isVirtual }: Facility,
  projectNames: string[] = []
): IItem | undefined {
  if (!name || !facilityAlias || !companyAlias) return;
  if (!isActive) return;
  return {
    key: id,
    description: name,
    label: `${companyAlias}_${facilityAlias}`,
    searchString: [name, companyAlias, facilityAlias, `${companyAlias}_${facilityAlias}`, ...projectNames].join(' '),
    className: isVirtual ? SEARCH_BAR_VIRTUAL_ITEM_CLASS : undefined,
  };
}
